export default __webpack_public_path__ + "static/media/circle-icon3.2b33f31f.png";